<template>
    <button
        type="button"
        class="btn btn-sm btn-link help-button"
        aria-label="Open help"
        title="Help (?)"
        @click="helpStore.toggle()"
    >
        <icon-material-symbols-help-outline class="fa-fw" />
    </button>
</template>

<script lang="ts">
import { useHelpStore } from '@/stores/helpStore';

// Module-scoped so every mounted HelpButton shares a single `keydown` listener.
// HelpButton is rendered in several places (sidebar, modals); registering the
// listener per-instance caused the `?` shortcut to toggle multiple times and
// cancel out.
let mountedCount = 0;

function onKey(event: KeyboardEvent): void {
    if (event.key !== '?') {
        return;
    }
    const target = event.target as HTMLElement | null;
    if (target && (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName))) {
        return;
    }
    event.preventDefault();
    useHelpStore().toggle();
}
</script>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';

const helpStore = useHelpStore();

onMounted(() => {
    if (mountedCount === 0) {
        window.addEventListener('keydown', onKey);
    }
    mountedCount += 1;
});

onBeforeUnmount(() => {
    mountedCount = Math.max(0, mountedCount - 1);
    if (mountedCount === 0) {
        window.removeEventListener('keydown', onKey);
    }
});
</script>

<style scoped>
.help-button {
    color: inherit;
    opacity: 0.7;
    padding: 0.25rem 0.5rem;
    font-size: 1.25rem;
    text-decoration: none;
}

.help-button:hover,
.help-button:focus {
    color: inherit;
    opacity: 1;
    text-decoration: none;
}
</style>
